import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import moment from 'moment';
import { Redirect, useHistory } from 'react-router-dom';
import { Timeline, Pagination } from 'antd';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import StatusBadge from "../common_component/StatusBadge.js";
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";
import formatNumber from '../common_component/formatNumber.js';

export const ViewdDeliveryOrder = (props) => {
	const [deliveryOrderDetails, setDeliveryOrderDetails] = useState([]);
	const [deliveryOrderHistoryDetails, setDeliveryOrderHistoryDetails] = useState([]);
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

	const [itemDetails, setItemDetails] = useState([]);
	const [warehouseAddress, setWarehouseAddress] = useState({});
	const [billingAddress, setBillingAddress] = useState({});
	const [shippingAddress, setShippingAddress] = useState({});
	const [orderCurrency, setOrderCurrency] = useState("");

	const [approveOrderModalShow, setApproveOrderModalShow] = useState(false);
	const [cancelOrderModalShow, setCancelOrderModalShow] = useState(false);
	const [cancelPickupModalShow, setCancelPickupModalShow] = useState(false);
	const [pushOrderModalShow, setPushOrderModalShow] = useState(false);
	const [generateAwbModalShow, setGenerateAwbModalShow] = useState(false);
	const [shipmentPickupModalShow, setShipmentPickupModalShow] = useState(false);
	const [generateShippingLabelModalShow, setGenerateShippingLabelModalShow] = useState(false);

	const [courierPartner, setCourierPartner] = useState(null);
	const [courierPartnerList, setCourierPartnerList] = useState([]);
	const [courierCurrency, setCourierCurrency] = useState("INR");
	const [courierPartnerListApiState, setCourierPartnerListApiState] = useState(false);
	const [approveType, setApproveType] = useState("");
	const [shippingProviderType, setShippingProviderType] = useState("");
	const [deliveryOrderId, setDeliveryOrderId] = useState("")
	const [statusType, setStatusType] = useState({ label: "All", value: "All" });
	const [status, setstatus] = useState("");

	const [progressModalShow, setProgressModalShow] = useState(false)
	const [flowApiState, setFlowApiState] = useState(false)
	const [trackingData, setTrackingData] = useState(null);

	const [state, setstate] = useState(2);

	const [allDayCheck, setAllDayCheck] = useState(true)
	const [scheduleTime, setScheduleTime] = useState(new Date().getHours() + ":" + new Date().getMinutes())
	const [scheduleDate, setScheduleDate] = useState(moment().utc().add(7, "days").format("YYYY-MM-DD"))
	const [userRole, setUserRole] = useState("")

	const [approvalChainPopup, setApprovalChainPopup] = useState(false)

	const [approveFinalButtonShow, setApproveFinalButtonShow] = useState(false)
	const [approveButtonShow, setApproveButtonShow] = useState(false)
	const [cancelButtonShow, setCancelButtonShow] = useState(false)

	const [submitButtonState, setSubmitButtonState] = useState(false);

	const apiController = useRef(new AbortController())

	var page_name = "view-delivery-order";

	const { user, read, write, visibility, organization_id } = useAuthData(page_name);

	let formatNumberOptions = {
		removeTrailingZeros: true
	}

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	async function getOrderDetails() {
		try {
			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-delivery-order-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "id": props.match.params.id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();

			if (body.operation === "success" && body.data.length > 0) {
				setDeliveryOrderDetails(body.data);
				setOrderCurrency(body.data[0].order_currency);
				setDeliveryOrderHistoryDetails(body.data[0].history_details);
				const response = await fetch(
					`${process.env.REACT_APP_SERVER_URL}/individual-user-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "unique_id": "", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
				);
				const t_body = await response.json();

				let user_role = t_body.data[0].user_role
				setUserRole(t_body.data[0].user_role)

				if (user_role === "Admin") {
					setApproveFinalButtonShow(true)
					setCancelButtonShow(true)
				}

				let t1 = (body.data[0].approval_info)
				let t2 = body.data[0].add_status
				let t3 = body.data[0].approval_level

				if (t2 === "DELIVERY_ORDER_PENDING_APPROVAL") {
					if (t1.type === "multilevel_approval") {

						let tl = t1.value.find(x => x.level === (t3 == null ? 1 : t3 + 1)).user_value
						if (tl.includes(user.email)) {
							setApproveButtonShow(true)
						}

						let tl2 = t1.value.map(x => x.user_value).flat(1)
						if (tl2.includes(user.email)) {
							setCancelButtonShow(true)
						}
					}
					else if (t1.type === "custom_approval") {
						let ty = t1.value[0]
						if (ty.user_type === "Group User") {
							if (ty.user_value.includes(user_role)) {
								setApproveButtonShow(true)
								setCancelButtonShow(true)
							}
						}
						else if (ty.user_type === "Individual User") {
							if (ty.user_value.includes(user.email)) {
								setApproveButtonShow(true)
								setCancelButtonShow(true)
							}
						}
					}
				}

				setItemDetails(body.data[0].order_data.order_items);
				setBillingAddress(body.data[0].order_data.billing_address);
				setWarehouseAddress(body.data[0].order_data.warehouse_details);
				setShippingAddress(body.data[0].order_data.shipping_address);
			}
			else {
				throw "no details api error"
			}
		}
		catch (err) {
			if (err.name !== 'AbortError') {
				console.log(err)
				throw err;
			}
		}
	}

	async function checkCourierServiceability(order_id) {
		if (courierPartnerListApiState) {
			apiController.current.abort()
			apiController.current = new AbortController()
		}
		setCourierPartnerListApiState(true)
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/check-courier-serviceability`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "order_id": order_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		setCourierPartnerListApiState(false);
		if (body.operation == "success") {
			setCourierCurrency(body.data.currency);
			setCourierPartnerList(body.data.available_courier_companies);
		}
	}

	useEffect(() => {
		if ((read || write) && (user.email && visibility)) {

			let p1 = getOrderDetails()

			Promise.all([p1])
				.then(() => {
					setstate(1);
					console.log("all apis done")
				})
				.catch((err) => {
					setstate(0);
					console.log(err)
				})
		}
	}, [user, visibility, read, write])

	// Custom single-value display
	const customSingleValue = ({ data }) => (
		<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
			<span>{data.label}</span>
			<span style={{ fontSize: "0.85rem", color: "#888" }}>
				{courierCurrency == "INR" && "₹"}{data.rate} | ⭐ {data.rating}
			</span>
		</div>
	);

	// Custom option layout
	const customOption = (props) => {
		const { data, innerRef, innerProps } = props;
		return (
			<div
				ref={innerRef}
				{...innerProps}
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					padding: "8px 12px",
					cursor: "pointer",
					backgroundColor: props.isFocused ? "#f0f0f0" : "white",
					borderBottom: "1px solid #e6e6e6",
				}}
			>
				<div>
					<strong>{data.label}</strong>
				</div>
				<div style={{ fontSize: "0.85rem", color: "#555" }}>
					{courierCurrency == "INR" && "₹"}{data.rate} | ⭐ {data.rating}
				</div>
			</div>
		);
	};

	const cancelPickupDetails = () => {
		var object = {};

		object.order_id = deliveryOrderId;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-shipping-pickup-request`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			setCancelPickupModalShow(false)
			if (res.data.operation === "success") {
				swal("Great!", `Shipping order details cancelled successfully!`, "success").then(() => {
					getOrderDetails();
				})
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const cancelOrderDetails = () => {
		var object = {};

		object.order_id = deliveryOrderId;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-shipping-order-details`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			setCancelOrderModalShow(false)
			if (res.data.operation === "success") {
				swal("Great!", `Shipping order details cancelled successfully!`, "success").then(() => {
					getOrderDetails();
				})
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const approveOrderSubmit = (final_flag, id) => {
		var object = {};
		object.final_flag = final_flag
		object.user_role = userRole
		object.id = id
		object.user_email = user.email

		object.organization_id = organization_id
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-delivery-order`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data.operation === "success") {
				swal("Great!", `Delivery order details approved successfully!`, "success").then(() => {
					setApproveOrderModalShow(false);
					getOrderDetails();
				})
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const shipmentPickup = () => {
		var object = {};
		object.schedule_date = scheduleDate;
		object.schedule_time = scheduleTime;
		object.order_id = deliveryOrderId;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/request-for-shipment-pickup`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			setShipmentPickupModalShow(false)
			if (res.data.operation === "success") {
				swal("Great!", `Pickup requested successfully!`, "success").then(() => {
					getOrderDetails();
				})
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const generateTrackingDetails = (delivery_order_id) => {
		var object = {};
		setFlowApiState(true);
		object.order_id = delivery_order_id;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true);

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/tracking-shipping-order-details`, object, headers).then((res) => {
			setMainSubmitButtonState(false);
			if (res.data.operation === "success") {
				setTrackingData(res.data.data);
				setFlowApiState(false);
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const generateShippingLabel = (delivery_order_id) => {
		var object = {};

		object.order_id = delivery_order_id;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true);

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/generate-shipment-label`, object, headers).then((res) => {
			setMainSubmitButtonState(false);
			setGenerateShippingLabelModalShow(false);
			if (res.data.operation === "success") {
				window.location.href = res.data.link;
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const generateAwbDetails = () => {
		var object = {};
		if (courierPartner == null) {
			swal("Oops!", "Courier partner need to be select", "error");
			return
		}
		object.courier_id = courierPartner.value;
		object.order_id = deliveryOrderId;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/generate-AWB-for-shipment`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			setGenerateAwbModalShow(false)
			if (res.data.operation === "success") {
				swal("Great!", `Waybill generated successfully!`, "success").then(() => {
					getOrderDetails();
				})
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	const updateStatus = (id, add_status) => {
		setDeliveryOrderId(id);
		setstatus(add_status);
		setApproveOrderModalShow(true);
	}

	const pushOrderDetails = () => {
		var object = {};

		object.order_id = deliveryOrderId;
		object.organization_id = organization_id;
		object.page_name = page_name;

		setMainSubmitButtonState(true)

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/save-shipping-order-details`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			setPushOrderModalShow(false)
			if (res.data.operation === "success") {
				swal("Great!", `Shipment Creation successfully!`, "success").then(() => {
					setPushOrderModalShow(false);
					getOrderDetails();
				})
			}
			else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
				swal("Oops!", "Wrong credential!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
				swal("Oops!", "No data available!", "error");
			}
			else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
				swal("Oops!", "Settings are not configured!", "error");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		})
			.catch(function (error) {
				console.log(error)
			});
	}

	// Function to render scan details in Timeline
	const renderTimelineItems = (data) => {
		//console.log(data)
		if (shippingProviderType == "Delhivery") {
			return data.Scans.map((scan, index) => (
				<Timeline.Item
					key={index}
					color={scan.ScanDetail.StatusCode === 'X-PNP' ? 'red' : 'green'}
				//label={new Date(scan.ScanDetail.ScanDateTime).toLocaleString()}
				>
					<div>
						<strong>{moment(scan.ScanDetail.ScanDateTime).format('DD MMM YYYY, hh:mm a')}</strong>
					</div>
					<div>{scan.ScanDetail.Instructions} at {scan.ScanDetail.ScannedLocation}</div>
				</Timeline.Item>
			));
		}
		else {
			return data.shipment_track_activities.map((item, index) => (
				<Timeline.Item key={index} color="green">
					<div>
						<strong>{moment(item.date).format('DD MMM YYYY, hh:mm a')}</strong>
					</div>
					<div>{item.sr_status_label} at {item.location || 'Unknown Location'}</div>
					<div>{item.activity && `Activity: ${item.activity}`}</div>
				</Timeline.Item>
			))
		}
	};

	return (
		<>
			<div>
				<div className="d-flex flex-stack">
					<div className="page-title me-3">
						<h1 className="page-heading text-dark fw-bold fs-3 my-0">View Delivery Order</h1>
					</div>
					{
						state === 1 &&
						<div className="d-flex align-items-center gap-2 gap-lg-3">
							{
								approveFinalButtonShow && deliveryOrderDetails[0].add_status === "DELIVERY_ORDER_PENDING_APPROVAL" && (
									<button className='btn btn-primary btn-sm' onClick={(e) => { setApproveType("final_approve"); updateStatus(deliveryOrderDetails[0].delivery_order_id, deliveryOrderDetails[0].add_status); }}
									>Final Approve</button>
								)
							}
							{
								approveButtonShow && deliveryOrderDetails[0].add_status === "DELIVERY_ORDER_PENDING_APPROVAL" && (
									<button className='btn btn-primary btn-sm' data-kt-indicator={submitButtonState ? "on" : "off"} disabled={submitButtonState}
										onClick={(e) => { setApproveType("approve"); updateStatus(deliveryOrderDetails[0].delivery_order_id, deliveryOrderDetails[0].add_status); }}
									>Approve</button>
								)
							}

							{
								(deliveryOrderDetails[0].add_status !== "DELIVERY_ORDER_CANCELLED") && deliveryOrderDetails[0].add_status === "DELIVERY_ORDER_PENDING_APPROVAL" && (
									<button className='btn btn-danger btn-sm'
										onClick={() => { setDeliveryOrderId(deliveryOrderDetails[0].delivery_order_id); setCancelOrderModalShow(true); }}
									>Cancel Order</button>
								)
							}
							{
								(deliveryOrderDetails[0].add_status == "DELIVERY_ORDER_READY_TO_SHIP" || deliveryOrderDetails[0].add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") &&
								<button className="btn btn-primary btn-sm rounded me-6" onClick={() => { setDeliveryOrderId(deliveryOrderDetails[0].delivery_order_id); setGenerateShippingLabelModalShow(true); generateShippingLabel(deliveryOrderDetails[0].delivery_order_id); }}>
									Generate Shipping Label</button>
							}
							{
								(deliveryOrderDetails[0].add_status == "DELIVERY_ORDER_FINALIZED") &&
								<button className="btn btn-primary btn-sm rounded me-6" onClick={() => { setShippingProviderType(deliveryOrderDetails[0].shipping_provider_type); setDeliveryOrderId(deliveryOrderDetails[0].delivery_order_id); setPushOrderModalShow(true); }}>
									Shipment Creation</button>
							}
							{
								(deliveryOrderDetails[0].shipping_provider_type == "ShipRocket" && deliveryOrderDetails[0].add_status == "DELIVERY_ORDER_PUSHED") &&
								<button className="btn btn-primary btn-sm rounded me-6" onClick={() => { setDeliveryOrderId(deliveryOrderDetails[0].delivery_order_id); checkCourierServiceability(deliveryOrderDetails[0].delivery_order_id); setGenerateAwbModalShow(true); }}>
									Generate AWB</button>
							}
							{
								(deliveryOrderDetails[0].add_status == "DELIVERY_ORDER_READY_TO_SHIP") &&
								<button className="btn btn-success btn-sm rounded me-6" onClick={() => { setShippingProviderType(deliveryOrderDetails[0].shipping_provider_type); setDeliveryOrderId(deliveryOrderDetails[0].delivery_order_id); setShipmentPickupModalShow(true); }}>
									Request Pickup</button>
							}
							{
								(deliveryOrderDetails[0].add_status !== "DELIVERY_ORDER_PENDING_APPROVAL" && deliveryOrderDetails[0].add_status !== "DELIVERY_ORDER_FINALIZED" && deliveryOrderDetails[0].add_status !== "DELIVERY_ORDER_PUSHED" && deliveryOrderDetails[0].add_status !== "DELIVERY_ORDER_CANCELLED") &&
								<button className="btn btn-info btn-sm rounded me-6" onClick={() => { setShippingProviderType(deliveryOrderDetails[0].shipping_provider_type); setDeliveryOrderId(deliveryOrderDetails[0].delivery_order_id); generateTrackingDetails(deliveryOrderDetails[0].delivery_order_id); setProgressModalShow(true); }}>
									Generate Tracking</button>
							}
						</div>
					}
				</div>
				<div>
					{
						state === 1 ?
							<div className="d-flex flex-column gap-7 gap-lg-10">
								<div className="d-flex flex-wrap flex-stack gap-5 gap-lg-10">
									<ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-lg-n2 me-auto" role="tablist">
										<li className="nav-item" role="presentation">
											<a className="nav-link text-active-primary pb-4 active" data-bs-toggle="tab" href="#kt_ecommerce_sales_order_summary" aria-selected="true" role="tab">Order Summary</a>
										</li>
										<li className="nav-item" role="presentation">
											<a className="nav-link text-active-primary pb-4" data-bs-toggle="tab" href="#kt_ecommerce_sales_order_history" aria-selected="false" role="tab" tabIndex="-1">Order History</a>
										</li>
									</ul>
								</div>
								<div className="tab-content">
									<div className="tab-pane fade active show" id="kt_ecommerce_sales_order_summary" role="tab-panel">
										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card border border-primary flex-equal">
													<div className="card-header">
														<div className="card-title">
															<h2>Order Details (#{deliveryOrderDetails[0].order_number})</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Status
																			</div>
																		</td>
																		<td className="fw-bold text-end">
																			<div style={{ position: "relative", display: "inline-block" }} >
																				<button className={`py-2 me-1 rounded btn btn-sm`}
																					onClick={() => { setApprovalChainPopup(true); }}
																					onBlur={() => { setApprovalChainPopup(false) }}
																				>
																					<StatusBadge status={deliveryOrderDetails[0].add_status} entity={"DELIVERY_ORDER"} />
																				</button>
																				{
																					(deliveryOrderDetails[0].approval_info !== null && deliveryOrderDetails[0].approval_info.value.length > 0) &&
																					<div style={{ position: "absolute", right: "0px", top: "30px", boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)", backgroundColor: "#FFFFFF", color: "black", padding: "1rem", width: "25rem", borderRadius: "0.5rem", transition: "all 0.25s ease-in-out", zIndex: 1, opacity: approvalChainPopup ? "1" : "0", visibility: approvalChainPopup ? "visible" : "hidden" }}>
																						{
																							(deliveryOrderDetails[0].approval_info).type === "multilevel_approval" ?
																								<>
																									<div className='text-center border-bottom fs-4'>Multilevel Approval</div>
																									<div>
																										{
																											(deliveryOrderDetails[0].approval_info).value.map((obj, i) => {
																												return (
																													<div key={i} className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
																														<div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
																														<div className='flex-grow-1 text-start'>
																															<div className='fs-4'>Level {obj.level}</div>
																															{
																																obj.user_value.map((val, j) => {
																																	return <div key={j} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
																																})
																															}
																														</div>
																														<div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
																													</div>
																												)
																											})
																										}

																										<div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
																											<i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
																											<div className='fs-4'>Approved</div>
																										</div>
																									</div>
																								</>
																								:
																								(deliveryOrderDetails[0].approval_info).type === "custom_approval" &&
																								<>
																									<div className='text-center border-bottom fs-4'>Custom Approval</div>
																									<div>
																										<div className='mx-auto mt-2 gap-5' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px", position: "relative", marginBottom: "30px" }}>
																											<div style={{ width: "30px", height: "30px", border: "5px #ffc700 solid", borderRadius: "10px" }}></div>
																											<div className='flex-grow-1 text-start'>
																												<div className='fs-4'>{(deliveryOrderDetails[0].approval_info).value[0].user_type}</div>
																												{
																													(deliveryOrderDetails[0].approval_info).value[0].user_value.map((val, i) => {
																														return <div key={i} className="fs-7"><span className='bullet bg-primary me-2'></span>{val}</div>
																													})
																												}
																											</div>
																											<div style={{ position: "absolute", width: "2px", height: "30px", backgroundColor: "darkgray", top: "100%", left: "24px" }}></div>
																										</div>
																										<div className='mx-auto my-2 gap-20' style={{ width: "95%", backgroundColor: "#edf0f2", borderRadius: "10px", display: "flex", alignItems: "center", padding: "10px" }}>
																											<i className="fa-solid fa-star fs-1" style={{ color: "#ff8100" }} ></i>
																											<div className='fs-4'>Approved</div>
																										</div>
																									</div>
																								</>
																						}
																					</div>}
																			</div>
																		</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Order Date
																			</div>
																		</td>
																		<td className="fw-bold text-end">{moment(deliveryOrderDetails[0].order_date).format("ll")}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																						<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																					</svg>
																				</span>Invoice Number
																			</div>
																		</td>
																		<td className="fw-bold text-end">{deliveryOrderDetails[0].invoice_number}</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
												<div className="card border border-primary flex-equal">
													<div className="card-header">
														<div className="card-title">
															<h2>Additional Details</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="table-responsive">
															<table className="table align-middle table-row-bordered mb-0 fs-6 gy-5 min-w-300px">
																<tbody className="fw-semibold text-gray-600">
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>Order type
																			</div>
																		</td>
																		<td className="fw-bold text-end">{deliveryOrderDetails[0]?.order_type}</td>
																	</tr>
																	<tr>
																		<td className="text-muted">
																			<div className="d-flex align-items-center">
																				<span className="svg-icon svg-icon-2 me-2">
																					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
																						<path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="currentColor"></path>
																						<path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="currentColor"></path>
																						<path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="currentColor"></path>
																					</svg>
																				</span>Shipping Provider
																			</div>
																		</td>
																		<td className="fw-bold text-end">{deliveryOrderDetails[0]?.shipping_provider_type}</td>
																	</tr>
																	<tr>
																		<tr>
																			<td className="text-muted">
																				<div className="d-flex align-items-center">
																					<span className="svg-icon svg-icon-2 me-2">
																						<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
																							<path opacity="0.3" d="M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z" fill="currentColor"></path>
																							<path d="M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z" fill="currentColor"></path>
																						</svg>
																					</span>Associated Challan No.
																				</div>
																			</td>
																			<td>{deliveryOrderDetails[0]?.delivery_challan_array.map((challan, i) => (<span key={i} className={`fw-semibold badge badge-primary m-1`}>{challan.challan_number}</span>))}</td>
																		</tr>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>

											<div className="d-flex flex-column flex-xl-row gap-7 gap-lg-10">
												<div className="card border border-info flex-equal">
													<div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
														<img src="/assets/media/icons/duotune/ecommerce/ecm004.svg" className="w-175px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Warehouse Address</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="address-info">
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {warehouseAddress.name}, {warehouseAddress.city}, {warehouseAddress.state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {warehouseAddress.postalcode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {warehouseAddress.country}
															</div>
														</div>
													</div>
												</div>
												<div className="card border border-info flex-equal">
													<div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
														<img src="/assets/media/icons/duotune/ecommerce/ecm006.svg" className="w-175px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Billing Address</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="address-info">
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {billingAddress.billing_city}, {billingAddress.billing_state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {billingAddress.billing_pincode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {billingAddress.billing_country}
															</div>
														</div>
													</div>
												</div>
												<div className="card border border-info flex-equal">
													<div className="position-absolute top-0 end-0 opacity-10 pe-none text-end">
														<img src="/assets/media/icons/duotune/ecommerce/ecm006.svg" className="w-175px" alt="Location Icon" />
													</div>
													<div className="card-header">
														<div className="card-title">
															<h2>Shipping Address</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="address-info">
															<div className="location">
																<i className="fas fa-map-marker-alt"></i> {shippingAddress.shipping_city}, {shippingAddress.shipping_state}
															</div>
															<div className="pincode">
																<i className="fas fa-thumbtack"></i> {shippingAddress.shipping_pincode}
															</div>
															<div className="country">
																<i className="fas fa-globe"></i> {shippingAddress.shipping_country}
															</div>
														</div>
													</div>
												</div>
											</div>


											<div className="card border border-success flex-equal">
												<div className="card-header align-items-center py-5 gap-2 gap-md-5">
													<div className="card-title">
														<h2>Order Details #{deliveryOrderDetails[0].order_number}</h2>
													</div>
												</div>
												<div className="card-body pt-0">
													<div className="d-flex justify-content-between flex-column">
														<div className="table-responsive border-bottom mb-9">
															<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																<thead>
																	<tr className="border-bottom fs-6 fw-bold text-muted">
																		<th className="min-w-100px">Products</th>
																		<th className="min-w-70px">Quantity</th>
																		<th className="min-w-70px">Rate</th>
																		<th className="min-w-100px text-end pb-2">Line Total</th>
																	</tr>
																</thead>
																<tbody className="fw-semibold text-gray-600">
																	{itemDetails.map((Obj, index) => {
																		return (
																			<tr key={index}>
																				<td>
																					<div className="fw-bold">
																						<div className="fw-bold">{Obj.item_name}</div>

																					</div>
																				</td>
																				<td>{Obj.quantity}</td>
																				<td>{orderCurrency.currency_symbol}{formatNumber(Obj.rate, { ...formatNumberOptions, decimalPlaces: orderCurrency.decimal_place })}</td>
																				<td className="text-end">{orderCurrency.currency_symbol}{formatNumber((((Obj.quantity * Obj.rate) - (Obj.discount_type === "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) + (Obj.taxable === 0 ? 0 : ((Obj.quantity * Obj.rate) - (Obj.discount_type === "amount" ? Obj.discount_unit : Obj.quantity * Obj.rate * Obj.discount_unit / 100)) * (Obj.tax_group_percentage / 100))), { ...formatNumberOptions, decimalPlaces: orderCurrency.decimal_place })}</td>
																			</tr>
																		)
																	})}

																</tbody>
															</table>
														</div>
														<div className="mw-300px ms-auto">
															<div className="d-flex flex-stack mb-3">
																<div className="fw-semibold pe-10 text-gray-600 fs-7">Subtotal:</div>
																<div className="text-end fw-bold fs-6 text-gray-800">{orderCurrency.currency_symbol} {formatNumber(itemDetails.reduce((p, o) => { return (p + (((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) + (o.taxable === 0 ? 0 : ((o.quantity * o.rate) - (o.discount_type === "amount" ? o.discount_unit : o.quantity * o.rate * o.discount_unit / 100)) * (o.tax_group_percentage / 100)))); }, 0), { ...formatNumberOptions, decimalPlaces: orderCurrency.decimal_place })}</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="tab-pane fade" id="kt_ecommerce_sales_order_history" role="tab-panel">
										<div className="d-flex flex-column gap-7 gap-lg-10">
											<div className="card border border-info card-flush py-4 flex-row-fluid">
												<div className="card-header">
													<div className="card-title">
														<h2>Order History</h2>
													</div>
												</div>
												{console.log(deliveryOrderHistoryDetails)}
												<div className="card-body pt-0">
													{
														deliveryOrderHistoryDetails.length > 0 ?
															<div className="table-responsive">
																<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																	<thead>
																		<tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
																			<th className="min-w-100px">Date Added</th>
																			<th className="min-w-175px">Comment</th>
																			<th className="min-w-70px">Order Status</th>
																			<th className="min-w-100px">Customer Notifed</th>
																		</tr>
																	</thead>
																	<tbody className="fw-semibold text-gray-600">
																		{deliveryOrderHistoryDetails.map((Obj, index) => {
																			return (
																				<tr key={index}>
																					<td>{moment(Obj.timestamp).format("ll")}</td>
																					<td>{Obj.operation_message}</td>
																					<td>
																						<StatusBadge status={Obj.delivery_order_status} entity={"DELIVERY_ORDER"} />
																					</td>
																					<td>
																						{(Obj.delivery_order_status === "DELIVERY_ORDER_RECEIVED" || Obj.delivery_order_status === "DELIVERY_ORDER_SHIPPED") ?
																							<>Yes</> : <>No</>}
																					</td>
																				</tr>
																			)
																		})}
																	</tbody>
																</table>
															</div>
															:
															null
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							: state === 2 ?
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								:
								<PageError message='No Data Available' />
					}
				</div>
			</div >

			<Modal show={progressModalShow} onHide={() => { setProgressModalShow(false); }} size="md" centered>
				<Modal.Body>
					<div className="position-absolute top-0 end-0 p-5">
						<div onClick={() => { setProgressModalShow(false); }} className="cursor-pointer">
							<i className="bi bi-x-circle fs-1 text-danger"></i>
						</div>
					</div>
					<div className='container mt-6'>
						{flowApiState === true && (
							<div className="text-center">
								<span>Loading...</span>
								<svg width="50" height="15" viewBox="0 45 100 10">
									<g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
									<g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
									<g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
									<g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
								</svg>
							</div>
						)}

						{flowApiState === false && (
							<>
								<Timeline mode="left">
									{(trackingData && trackingData) && renderTimelineItems(trackingData)}
								</Timeline>
							</>
						)}
					</div>
				</Modal.Body>
			</Modal >
			<Modal show={pushOrderModalShow} onHide={() => { setPushOrderModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Shipment Creation</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPushOrderModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="col-lg-12">
							<h3>Are you ready for Shipment Creation?</h3>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setPushOrderModalShow(false) }} className="btn btn-secondary">Close</button>
					{write == 1 && <form >
						<button type="button" onClick={(e) => { pushOrderDetails(e) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Create</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>
			<Modal show={generateAwbModalShow} onHide={() => { setGenerateAwbModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Generate AWB for Shipment</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGenerateAwbModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="row gx-0 gap-5 m-2">
							<div className='col-md-8'>
								<label className="fs-5 fw-bold mb-2 required">Courier Partner</label>
								<Select
									options={courierPartnerList}
									onChange={(val) => { setCourierPartner(val); }}
									value={courierPartner}
									isLoading={courierPartnerListApiState}
									getOptionLabel={(e) => (
										<div style={{
											display: "flex", justifyContent: "space-between", alignItems: "center",
											padding: "8px 12px",
											cursor: "pointer",
											//backgroundColor: props.isFocused ? "#f0f0f0" : "white",
											borderBottom: "1px solid #e6e6e6"
										}}>
											<span>{e.label}</span>
											<span style={{ fontSize: "0.85rem", color: "#555" }}>
												{courierCurrency == "INR" && "₹"}{e.rate} | ⭐ {e.rating}
											</span>
										</div>
									)}
									components={{
										SingleValue: customSingleValue,
										Option: customOption,
									}}
									placeholder="Select Courier Partner"
									styles={{
										control: (provided) => ({
											...provided,
											padding: "5px",
											fontSize: "1rem",
										}),
									}}
								/>
							</div>
						</div>
						<div className="col-lg-12">
							<h3>Are you sure about Generate AWB for Shipment?</h3>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setGenerateAwbModalShow(false) }} className="btn btn-secondary">Close</button>
					{write == 1 && <form >
						<button type="button" onClick={(e) => { generateAwbDetails(e) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Generate</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>
			<Modal show={generateShippingLabelModalShow} onHide={() => { setGenerateShippingLabelModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Generate Shipping Label</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGenerateShippingLabelModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						{mainSubmitButtonState &&
							<div className="card">
								<div className="card-body pt-6">
									<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								</div>
							</div>
						}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setGenerateShippingLabelModalShow(false) }} className="btn btn-secondary">Close</button>
				</Modal.Footer>
			</Modal>
			<Modal show={shipmentPickupModalShow} onHide={() => { setShipmentPickupModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Request for Shipment Pickup</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setShipmentPickupModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="row mb-5 align-items-center">
							<div className='col-4'>
								<label className="fs-5 fw-bold">Pickup Date</label>
							</div>
							<div className="col-8">
								<input type="date" className='form-control form-control-solid' value={scheduleDate} onChange={(e) => { setScheduleDate(e.target.value) }} />
							</div>
						</div>

						<div className="row mb-5 align-items-center">
							<div className="col-6 col-md-4">
								<label className="required fs-5 fw-bold">All Day</label>
							</div>
							<div className='col-6 col-md-2'>
								<div className="form-switch">
									<input className="form-check-input w-45px h-30px" type="checkbox" checked={allDayCheck} onChange={(e) => { setAllDayCheck(e.target.checked) }} />
								</div>
							</div>
							{
								(!allDayCheck && shippingProviderType == "Delhivery") &&
								<>
									<div className='col-3'>
										<input type="time" className='form-control form-control-solid' value={scheduleTime} onChange={(e) => { setScheduleTime(e.target.value) }} disabled={allDayCheck} />
									</div>
								</>
							}
						</div>
						<div className="col-lg-12">
							<h3>Are you sure about Request for Shipment Pickup?</h3>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setShipmentPickupModalShow(false) }} className="btn btn-secondary">Close</button>
					{write == 1 && <form >
						<button type="button" onClick={(e) => { shipmentPickup(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Pickup</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>

			<Modal show={approveOrderModalShow} onHide={() => { setApproveOrderModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Approve Order</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setApproveOrderModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<center>
						<div className="form-group row">
							<div className="col-lg-12">
								Current Status is :<StatusBadge status={status} entity={"DELIVERY_ORDER"} />
								<br />
								<h3 className="mt-3">Are you sure about {approveType === "final_approve" && <>& Final</>} Approve Payment?</h3>
							</div>
						</div>
					</center>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setApproveOrderModalShow(false) }} className="btn btn-secondary">Close</button>
					{write && <form >
						<button type="button" onClick={(e) => {
							if (approveType === "final_approve") {
								approveOrderSubmit(true, deliveryOrderId)
							}
							else {
								approveOrderSubmit(false, deliveryOrderId)
							}
						}} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">{approveType === "final_approve" && <>Final </>}Approve </span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>

			<Modal show={cancelPickupModalShow} onHide={() => { setCancelPickupModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Cancel Pickup Request</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setCancelPickupModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="col-lg-12">
							<h3>Are you sure about cancelling pickup request?</h3>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setCancelPickupModalShow(false) }} className="btn btn-secondary">Close</button>
					{write == 1 && <form >
						<button type="button" onClick={(e) => { cancelPickupDetails(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>

			<Modal show={cancelOrderModalShow} onHide={() => { setCancelOrderModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Cancel Order</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setCancelOrderModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="col-lg-12">
							<h3>Are you sure about cancelling order?</h3>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" onClick={(e) => { setCancelOrderModalShow(false) }} className="btn btn-secondary">Close</button>
					{write == 1 && <form >
						<button type="button" onClick={(e) => { cancelOrderDetails(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
							<span className="indicator-progress">Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
					</form>}
				</Modal.Footer>
			</Modal>
		</>);

};

export default ViewdDeliveryOrder;
